import { useState } from 'react';

import { ProductNavigation } from '../../../../components/ui/ProductNavigation';
import { teachers, type CourseStatus } from './fixtures';
import styles from './Page.module.css';

const sideNavigation = ['课程管理', '班级管理', '排课管理', '约课管理', '课表和点名', '补课管理', '评测管理', '考试管理', '宿舍管理', '学管师带班', '证书管理', '电子合同查询', '校管家云课', '升班关系设置', '在线课堂'];
const tabs = ['教师课表', '刷卡考勤', '刷卡记录'];

function statusLabel(status: CourseStatus | 'free') {
  return { completed: '已上完', inProgress: '上课中', upcoming: '等待上课', free: '空闲' }[status];
}

export function TeacherScheduleV1Page() {
  const [selectedTeacherId, setSelectedTeacherId] = useState('zhang');
  const [activeTab, setActiveTab] = useState('教师课表');
  const selectedTeacher = teachers.find((teacher) => teacher.id === selectedTeacherId) ?? teachers[0];

  return <main className={styles.page}>
    <ProductNavigation defaultActive="教务管理" />
    <div className={styles.workspace}>
      <aside aria-label="教务管理导航" className={styles.sideNavigation}>
        <p className={styles.sideTitle}>教务管理</p>
        <nav aria-label="教务功能">
          {sideNavigation.map((item) => <button aria-current={item === '课表和点名' ? 'page' : undefined} className={item === '课表和点名' ? styles.sideActive : styles.sideItem} key={item} type="button">{item}</button>)}
        </nav>
        <button className={styles.collapse} type="button">收起</button>
      </aside>

      <section className={styles.content}>
        <h1 className={styles.visuallyHidden}>教师课表</h1>
        <p className={styles.breadcrumb}>当前位置：教务管理 / 课表和点名 / 教师课表</p>
        <div className={styles.surface}>
          <div className={styles.tabs} role="tablist" aria-label="课表功能">
            {tabs.map((tab) => <button aria-selected={activeTab === tab} className={activeTab === tab ? styles.activeTab : styles.tab} key={tab} onClick={() => setActiveTab(tab)} role="tab" type="button">{tab}</button>)}
          </div>
          <div className={styles.summary}>
            <div><strong>2026年08月13日 周四</strong><span>系统时间 11:25:57</span></div>
            <div className={styles.summaryStats}><span>今日课程 <b>3</b></span><span>上课中 <b className={styles.info}>0</b></span><span>等待 <b className={styles.warning}>1</b></span><span>已上完 <b>2</b></span><span>每 1 分钟自动刷新</span><button type="button">刷新</button></div>
          </div>

          <div className={styles.scheduleLayout}>
            <section className={styles.teacherPanel} aria-label="教师列表">
              <header className={styles.panelHeader}><h2>教师 <span>{teachers.length} 位</span></h2><div><button aria-label="列表视图" className={styles.viewActive} type="button">列表</button><button aria-label="卡片视图" type="button">卡片</button></div></header>
              <div className={styles.teacherList}>
                {teachers.map((teacher) => <button aria-pressed={selectedTeacher.id === teacher.id} className={selectedTeacher.id === teacher.id ? styles.teacherSelected : styles.teacherCard} key={teacher.id} onClick={() => setSelectedTeacherId(teacher.id)} type="button">
                  <div className={styles.teacherCardTop}><strong>{teacher.name}</strong><span className={`${styles.status} ${styles[teacher.status]}`}>{statusLabel(teacher.status)}</span></div>
                  <span>{teacher.subject}老师</span>
                  <small>{teacher.nextCourse ?? '今日无课'}</small>
                </button>)}
              </div>
            </section>

            <section className={styles.timeline} aria-label={`${selectedTeacher.name}课表`}>
              <header className={styles.timelineHeader}><h1>{selectedTeacher.name} 课表 <span>{selectedTeacher.courses.length} 节课</span></h1><div className={styles.legend}><span><i className={styles.completed} />已上完</span><span><i className={styles.inProgress} />上课中</span><span><i className={styles.upcoming} />等待上课</span></div></header>
              {selectedTeacher.courses.length > 0 ? <div className={styles.courseList}>
                {selectedTeacher.courses.map((course, index) => <article className={styles.courseRow} key={`${course.start}-${course.title}-${index}`}>
                  <div className={styles.time}><strong>{course.start}</strong><span>{course.end}</span></div>
                  <i aria-hidden="true" className={`${styles.timelineDot} ${styles[course.status]}`} />
                  <div className={styles.courseCard}><div><h3>{course.title} <span>{course.duration}</span></h3><p>上课教室：{course.classroom}  助教：{course.assistant}</p><p>未点名 · {course.students}</p></div><button type="button">操作</button></div>
                </article>)}
              </div> : <div className={styles.emptyState}>今日暂无课程</div>}
            </section>
          </div>
        </div>
      </section>
    </div>
  </main>;
}
